import React from 'react'
import Svg, { Circle, G, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconDots = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconDots.dimensions.width} ${IconDots.dimensions.height}`}
      {...otherProps}
    >
      <G fill={color || Color.premiumBlack}>
        <Circle cx={2} cy={2.5} r={2} />
        <Circle cx={2} cy={10.5} r={2} />
        <Circle cx={2} cy={18.5} r={2} />
      </G>
    </Svg>
  )
}

IconDots.dimensions = {
  width: 4,
  height: 21,
}

export default IconDots
